import ViewerTop from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/ViewerTop/ViewerTop";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import CrossIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CrossIconPath";
import CloseButtonWrapper from "@coworker/apprestructured/src/task-management/components/SheetTop/CloseButtonWrapper/CloseButtonWrapper";
import styles from "./LoadingViewerTop.module.css";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";

type LoadingViewerTopProps = {
  onCloseButtonClick: () => void;
};

function LoadingViewerTop({ onCloseButtonClick }: LoadingViewerTopProps) {
  return (
    <ViewerTop className={styles["root"]} state={LOADING}>
      <CloseButtonWrapper>
        <FixaButton
          onClick={onCloseButtonClick}
          ssrIcon={CrossIconPath}
          iconOnly
          type="tertiary"
          inverseTheme
          size="small"
        />
      </CloseButtonWrapper>
    </ViewerTop>
  );
}

export default LoadingViewerTop;
